import React from 'react';
import AuctionBanner from "./AuctionBanner";
// import UpcomingAuction from "../auction/UpcomingAuction";
// import Product from "../products/"
import Auctions from "./Auctions"
import Page from "src/components/Page";
import { Helmet } from 'react-helmet';
function Index(props) {
 
    return (
        <>
{/* <Helmet>
<meta itemprop="name" content="Art Auctions at Leon Gallery | Philippine Art & Masterpieces" />
<meta property="og:title" content="Art Auctions at Leon Gallery | Philippine Art & Masterpieces" />
<meta name="twitter:title" content="Art Auctions at Leon Gallery | Philippine Art & Masterpieces" />
<meta itemprop="description" content="Explore upcoming and past art auctions at Leon Gallery. Discover Philippine masterpieces, rare collections, and renowned artists. Join our auctions for exclusive art opportunities." /> 
<meta property="og:description" content="Explore upcoming and past art auctions at Leon Gallery. Discover Philippine masterpieces, rare collections, and renowned artists. Join our auctions for exclusive art opportunities." />  
<meta name="twitter:description" content="Explore upcoming and past art auctions at Leon Gallery. Discover Philippine masterpieces, rare collections, and renowned artists. Join our auctions for exclusive art opportunities." />
<meta itemprop="image" content="https://leon-gallery.com/static/media/logo.df0c3dbcff15cc21dae9.jpg" /> 
<meta property="og:image" content="https://leon-gallery.com/static/media/logo.df0c3dbcff15cc21dae9.jpg" />
<meta name="twitter:image" content="https://leon-gallery.com/static/media/logo.df0c3dbcff15cc21dae9.jpg" /> 
</Helmet> */}
        <Page >
                  <AuctionBanner/>
                  {/* <Product/> */}
                  <Auctions/>
                  {/* <UpcomingAuction/> */}
        </Page>
        </>
    );
}

export default Index;


